import { createReducer } from 'reduxsauce'
import { Record, List } from 'immutable'
import { Value } from 'slate'
import { emptyData, placeholderData } from 'editor-data'
import { articleTypes } from '.'

// Selector
export const hasChanged = state =>
	state.articles.article.titleHasChanged ||
	state.articles.article.contentHasChanged

export const INITIAL_STATE = new Record({
	list: null,
	listIndex: new List(), // For page search
	article: {
		loading: false,
		id: null,
		order: null,
		parent: null,
		title: null,
		content: null,
		createdAt: null,
		createdBy: null,
		updatedAt: null,
		updatedBy: null,
		lockedBy: null,
		editorTitle: null,
		editorContent: null,
		titleHasChanged: false,
		contentHasChanged: false,
		ratings: [],
		status: null,
		draft: null,
		outdated: null,
	},
	saving: false,
	savingSuccess: null,
	savingFailure: null,
})

export const getArticlesSuccess = (state, { articles }) =>
	state.set('list', new List(articles.reverse()))
export const getArticlesIndexSuccess = (state, { articles }) =>
	state.set('listIndex', new List(articles.reverse()))

export const getArticleRequest = (state, { id, update = false }) =>
	state.merge({
		article: {
			...state.article,
			id,
			loading: !update,
			titleHasChanged: false,
			contentHasChanged: false,
			editorTitle: update ? state.article.editorTitle : '——––– ––––',
			editorContent: update
				? state.article.editorContent
				: Value.fromJSON(placeholderData),
		},
	})

export const getArticleSuccess = (state, { article }) => {
	const editorContent = article.content
		? Value.fromJSON(JSON.parse(article.content))
		: Value.fromJSON(emptyData)

	return state.merge({
		article: {
			editorTitle: article.title,
			editorContent,
			titleHasChanged: false,
			contentHasChanged: false,
			...article,
			loading: false,
			status: 200,
		},
	})
}
// return state.set('list', state.list.map(article => article.id ===
// action.payload.article.id ? action.payload.article : article))

export const createArticleSuccess = (state, { article }) =>
	state.list.find(a => a.id === article.id)
		? state
		: state.set('list', state.list.unshift(article))

export const removeArticleSuccess = (state, { article }) =>
	state.set(
		'list',
		state.list.filter(cArticle => cArticle.id !== article)
	)

export const duplicateArticleSuccess = (state, { article }) =>
	state.list.find(a => a.id === article.id)
		? state
		: state.set('list', state.list.unshift(article))

export const updateArticleStatus = (state, { status, loading = false }) =>
	state.merge({
		article: {
			...state.article,
			loading,
			status,
		},
	})

export const updateArticleRequest = state =>
	state.merge({
		saving: true,
		savingSuccess: null,
		savingFailure: null,
	})

export const rateArticleSuccess = (state, { user, state: ratingState }) => {
	const filteredRatings = state.article.ratings.filter(
		rating => rating.user !== user
	)
	const userHasAlreadySameRating = state.article.ratings.find(
		rating => rating.user === user && rating.like === ratingState
	)
	const newRating = filteredRatings

	if (!userHasAlreadySameRating) {
		newRating.push({ user, like: ratingState })
	}

	return state.merge({
		article: {
			...state.article,
			ratings: newRating,
		},
	})
}

export const updateArticleSuccess = (state, { article }) =>
	state.merge({
		// list: state.list.map(a => (a.id === article.id ? article : a)),
		list: state.list.map(a => {
			const ar = article

			// Do not set title since state already contains current title
			if (a.id === ar.id) {
				ar.title = a.title

				return ar
			}

			return a
		}),
		saving: false,
		savingSuccess:
			state.article.titleHasChanged ||
			state.article.contentHasChanged ||
			false,
		savingFailure: null,
		article: {
			...state.article,
			content: article.content,
			title: article.title,
			createdAt: article.createdAt,
			createdBy: article.createdBy,
			updatedAt: article.updatedAt,
			updatedBy: article.updatedBy,
			lockedBy: article.lockedBy,
			titleHasChanged: false,
			contentHasChanged: false,
		},
	})

export const updateArticleMeta = (state, { id = null, meta }) => {
	if (!id || id === state.article.id) {
		return state.merge({
			article: {
				...state.article,
				...meta,
			},
		})
	}

	return state
}

export const changeArticleStateSuccess = (state, { id, state: draftState }) =>
	state.merge({
		list: state.list.map(a => {
			const na = { ...a }

			if (na.id === id) {
				na.draft = draftState
			}

			return na
		}),
		article: {
			...state.article,
			draft: state.article.id === id ? draftState : state.article.draft,
		},
	})

export const changeOutdatedStateSuccess = (
	state,
	{ id, state: outdatedState }
) =>
	state.merge({
		list: state.list.map(a => {
			const na = { ...a }

			if (na.id === id) {
				na.outdated = outdatedState
			}

			return na
		}),
		article: {
			...state.article,
			outdated:
				state.article.id === id
					? outdatedState
					: state.article.outdated,
		},
	})

export const updateArticlesSuccess = (state, { articles }) =>
	state.set('list', new List(articles.reverse()))

export const changeEditorTitle = (state, { title }) =>
	state.merge({
		list: state.list.map(a => {
			const na = { ...a }

			if ((state.article.title || '') !== title) {
				if (na.id === state.article.id) {
					na.title = title
				}
			}

			return na
		}),
		article: {
			...state.article,
			editorTitle: title,
			titleHasChanged: (state.article.title || '') !== title,
		},
	})

export const changeEditorContent = (state, { content }) => {
	let { content: orignalContent } = state.article
	orignalContent =
		orignalContent === '' ? JSON.stringify(emptyData) : orignalContent
	const contentHasChanged = orignalContent !== JSON.stringify(content)

	return state.merge({
		article: {
			...state.article,
			editorContent: content,
			contentHasChanged,
		},
	})
}

export const wsArticleUpdate = (state, { user, article }) => {
	if (!article.id) return state

	const userIsUpdating = user === article?.lockedBy?.id
	let ar = null

	// If article update is current article
	if (state.article.id === article.id) {
		ar = {
			...state.article,
			lockedBy:
				article.lockedBy || article.lockedBy === null
					? article.lockedBy
					: state.article.lockedBy,
		}

		if (!userIsUpdating && article.title) {
			// Only update title
			ar = {
				...ar,
				...state.article,
				editorTitle: article.title
					? article.title
					: state.article.title,
				lockedBy:
					article.lockedBy || article.lockedBy === null
						? article.lockedBy
						: state.article.lockedBy,
			}
		}
	}

	return state.merge({
		list: state.list.map(a => {
			const na = { ...a }

			if (na.id === article.id) {
				// Only update article title in list if user is not author
				if (!userIsUpdating && article.title) {
					na.title = article.title
				}

				na.order = article.order ? article.order : na.order
				na.parent = article.parent ? article.parent : na.parent
				na.lockedBy =
					article.lockedBy || article.lockedBy === null
						? article.lockedBy
						: na.lockedBy
				na.draft = article.draft ? article.draft : na.draft
				na.outdated = article.outdated ? article.outdated : na.outdated
			}

			return na
		}),
		article: ar || state.article,
	})
}

export const resetArticleState = state =>
	state.merge({ article: INITIAL_STATE.article })

export const reducer = createReducer(INITIAL_STATE(), {
	[articleTypes.GET_ARTICLES_SUCCESS]: getArticlesSuccess,
	[articleTypes.GET_ARTICLES_INDEX_SUCCESS]: getArticlesIndexSuccess,
	[articleTypes.GET_ARTICLE_REQUEST]: getArticleRequest,
	[articleTypes.GET_ARTICLE_SUCCESS]: getArticleSuccess,
	[articleTypes.CREATE_ARTICLE_SUCCESS]: createArticleSuccess,
	[articleTypes.DUPLICATE_ARTICLE_SUCCESS]: duplicateArticleSuccess,
	[articleTypes.REMOVE_ARTICLE_SUCCESS]: removeArticleSuccess,
	[articleTypes.RATE_ARTICLE_SUCCESS]: rateArticleSuccess,
	[articleTypes.UPDATE_ARTICLE_REQUEST]: updateArticleRequest,
	[articleTypes.UPDATE_ARTICLE_SUCCESS]: updateArticleSuccess,
	[articleTypes.UPDATE_ARTICLE_META]: updateArticleMeta,
	[articleTypes.UPDATE_ARTICLES_SUCCESS]: updateArticlesSuccess,
	[articleTypes.CHANGE_EDITOR_TITLE]: changeEditorTitle,
	[articleTypes.CHANGE_EDITOR_CONTENT]: changeEditorContent,
	[articleTypes.UPDATE_ARTICLE_STATUS]: updateArticleStatus,
	[articleTypes.RESET_ARTICLE_STATE]: resetArticleState,
	[articleTypes.CHANGE_ARTICLE_STATE_SUCCESS]: changeArticleStateSuccess,
	[articleTypes.CHANGE_OUTDATED_STATE_SUCCESS]: changeOutdatedStateSuccess,

	[articleTypes.WS_ARTICLE_UPDATE]: wsArticleUpdate,
})
